(async function () {
  const familyCode     = window.SIBLING_FAMILY_CODE;   // e.g. 03426
  const sizeCode       = window.SIBLING_SIZE_CODE;     // e.g. xw / m / w
  const currentHandle  = window.CURRENT_HANDLE;
  const productType    = window.PRODUCT_TYPE;
  const plpComingSoon  = window.PLP_COMING_SOON;

  if (!familyCode || !currentHandle) return;

  const cacheKey = `siblings_${familyCode}_${sizeCode || 'all'}`;
  const cached = sessionStorage.getItem(cacheKey);

  let siblings = [];

  /* ----------------------------------------
     LOAD FROM CACHE
  ---------------------------------------- */
  if (cached) {
    siblings = JSON.parse(cached);
  } 
  /* ----------------------------------------
     FETCH + ASSIGN (Neptune-style)
  ---------------------------------------- */
  else {
    const res = await fetch(`/search?q=${encodeURIComponent(familyCode)}*&type=product`);
    const html = await res.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const items = doc.querySelectorAll('.grid__item');

    items.forEach(item => {
      const titleEl = item.querySelector('.card__heading a');
      const imgEl   = item.querySelector('img');
      const badge   = item.textContent || '';

      if (!titleEl) return;

      const title = titleEl.textContent.trim();

      // -------------------------------
      // BASE + SIZE (Neptune logic)
      // -------------------------------
      const base = title.split('-')[0]?.trim();
      const size = title
        .split('|')[0]
        ?.split('-')
        .pop()
        ?.trim();

      // ❌ family mismatch
      if (base !== familyCode) return;

      // ❌ size mismatch (FOOTWEAR only)
      if (productType === 'FOOTWEAR' && sizeCode && size !== sizeCode) return;

      const handle = titleEl.getAttribute('href')
        ?.split('/products/')[1]
        ?.split('?')[0];

      if (!handle) return;

      const available   = !badge.includes('Sold out');
      const comingSoon  = badge.includes('SMART_TAG_COMINGSOON');

      // -------------------------------
      // AVAILABILITY RULES (Neptune)
      // -------------------------------
      if (productType === 'FOOTWEAR') {
        if (plpComingSoon) {
          if (!available && !comingSoon) return;
        } else {
          if (!available) return;
        }
      } else {
        if (plpComingSoon) {
          if (!available && !comingSoon) return;
        } else {
          if (!available) return;
        }
      }

      // ✅ ASSIGN SIBLING (clean list)
      siblings.push({
        title,
        handle,
        image: imgEl?.src || '',
        available,
        comingSoon
      });
    });

    sessionStorage.setItem(cacheKey, JSON.stringify(siblings));
  }

  /* ----------------------------------------
     ENSURE CURRENT PRODUCT IS PRESENT
  ---------------------------------------- */
  if (!siblings.some(p => p.handle === currentHandle) && window.product) {
    siblings.unshift({
      title: window.product.title,
      handle: currentHandle,
      image: window.product.featured_image,
      available: window.product.available,
      comingSoon: window.product.tags?.includes('SMART_TAG_COMINGSOON')
    });
  }

  /* ----------------------------------------
     RENDER
  ---------------------------------------- */
  renderSiblings(siblings, currentHandle);

})();